var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"mt-10",staticStyle:{"text-align":"center"}},[_vm._v("Impressum:")]),_c('TextField',{attrs:{"text":_vm.text}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }